import { createReducer, on } from '@ngrx/store';
import { setLogin } from './user.actions';
import { UserProp } from './user.prop';
 
export const initialState: UserProp = {
    is_login: false,
    user: null
}
 
const _userReducer = createReducer(
  initialState,
  on(setLogin, (state, value) => {
    return value;
  })
);
 
export function userReducer(state, action) {
  return _userReducer(state, action);
}